<mat-dialog-content>
  <div class="container simple">
    <h1>Werde zum Reporter!</h1>
    <h2>Liveticker-Benachrichtigungen aktivieren</h2>
    <div class="item-entry">
      <img src="assets/icons/bell-bg-blue.svg" alt="Glocke"/>
      <p>Werde für Liveticker benachrichtigt</p>
    </div>
    <div class="item-entry">
      <img src="assets/icons/alarm-clock-bg-blue.svg" alt="Uhr"/>
      <p>Verpasse keine Anmeldung für den Liveticker mehr</p>
    </div>
    <div class="item-entry">
      <img src="assets/icons/star-bg-blue.svg" alt="Stern"/>
      <p>Berichte live vom Spiel deines Vereins und werde zur Tickerlegende</p>
    </div>
    <button (click)="onNotifications()">Benachrichtigungen aktivieren</button>
    <h2>Als Teamreporter anmelden</h2>
    <div class="item-entry">
      <img src="assets/icons/news-bg-blue.svg" alt="Zeitung"/>
      <p>Informiere über News und Spiele gleichzeitig auf deiner App-, Web- und Social Media-Seite</p>
    </div>
    <div class="item-entry">
      <img src="assets/icons/phone-bg-blue.svg" alt="Handy"/>
      <p>Sei fix Reporter in jedem Live-Ticker</p>
    </div>
    <div class="item-entry">
      <img src="assets/icons/shake-hands-bg-blue.svg" alt="Micro"/>
      <p>Integriere deine Sponsoren und erhöhe deren Medienpräsenz</p>
    </div>
    <button (click)="onRegister()">Jetzt anmelden</button>
  </div>
</mat-dialog-content>
